import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.316 18c1.39 0 2.526 1.125 2.526 2.5S7.705 23 6.316 23c-1.39 0-2.527-1.125-2.527-2.5S4.926 18 6.316 18zm11.368 0c1.39 0 2.527 1.125 2.527 2.5S19.074 23 17.684 23c-1.39 0-2.526-1.125-2.526-2.5s1.137-2.5 2.526-2.5zM5.305 15.75l15.537-.5c.38 0 .632.25.632.625s-.253.625-.632.625l-16.42.5c-.38.125-.759-.375-.633-.75l.758-2.375c.253-.625.253-1.125.127-1.75L3.41 5.25c-.127-.625-.632-1-1.264-1H.632C.252 4.25 0 4 0 3.625S.253 3 .632 3h22.105C23.495 3 24 3.5 24 4.25v7.125c0 .625-.505 1.125-1.137 1.25L5.684 14.5l-.379 1.25z"
});

var SvgCartFilled = function SvgCartFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCartFilled;